import { Modal, Tabs } from 'antd';
import React from 'react';
import FolderStructure from '../../../common/FolderStructure/FolderStructure';
import { DataRoom } from '../../deals/redux/types';

const { TabPane } = Tabs;

type Props = {
    executedAgreements: DataRoom[];
    updates: DataRoom[];
    setSelectedRow?: (v: string | undefined) => void;
    open: boolean;
    setOpen: (f: boolean) => void;
};
const ExcutedAgreementAndUpdatedFilesModel: React.FC<Props> = ({
    executedAgreements,
    updates,
    setSelectedRow,
    open,
    setOpen,
}) => {
    const onClickCancel = () => {
        setOpen(false);
        if (setSelectedRow) {
            setSelectedRow(undefined);
        }
    };

    return (
        <Modal open={open} title="Documents" footer={null} onCancel={onClickCancel} onOk={onClickCancel} centered>
            <Tabs className="investment_doc">
                {executedAgreements.length > 0 && (
                    <TabPane tab="Executed Agreements" key="1">
                        <FolderStructure dataFiles={executedAgreements} isDeal={false} />
                    </TabPane>
                )}
                {updates.length > 0 && (
                    <TabPane tab="Updates" key="2">
                        <FolderStructure dataFiles={updates} isDeal={false} />
                    </TabPane>
                )}
            </Tabs>
        </Modal>
    );
};

export default ExcutedAgreementAndUpdatedFilesModel;
